(ns app.dashboard.views
  (:require ["react-dnd" :refer (DndProvider useDrag useDrop)]
            ["react-dnd-html5-backend" :refer (HTML5Backend)]
            ["react-virtualized-auto-sizer" :as AutoSizer]
            ["react-window" :refer (FixedSizeList)]
            [app.account-settings.views :refer [account-settings-panel]]
            [app.components.buttons.views :as buttons]
            [app.components.cards.views :refer [activity-card
                                                create-product-card product-card time-ago]]
            [app.components.folder-items.drag-drop :refer [change-list]]
            [app.components.folder-items.views :as folder-items]
            [app.components.headers.views :refer [header]]
            [app.components.icons.views :refer [dashboard-icon delete-icon
                                                form-icon grid-view-icon
                                                list-view-icon new-folder-icon not-found-icon plus-icon plus-white-icon product-icon
                                                recycle-trash-icon search-icon-small trash-big-icon]]
            [app.components.menus.views :refer [account-settings create-menu
                                                workpaces-menu]]
            [app.components.pop-ups.views :refer [mui-action-snackbar
                                                  mui-snackbar
                                                  mutliselect-actions-pop-up pop-up]]
            [app.components.tables.views :refer [basic-table-with-checkbox]]
            [app.components.workspace-item.styles :refer [workspace-tooltip]]
            [app.components.workspace-item.views :refer [new_workspace
                                                         workspace_btn]]
            [app.dashboard.events :as wevents :refer [copy-link get-token]]
            [app.dashboard.math :refer [clean-num display-percentage
                                        open-rate-calc order-num response-rate-calc
                                        subs-calc subs-movement-calc]]
            [app.dashboard.math :refer [clean-num display-percentage
                                        open-rate-calc order-num response-rate-calc
                                        subs-calc subs-movement-calc]]
            [app.endpoints :refer [folder-link strive-react-endpoint]]
            [app.events :as events]
            [app.login.events :as login-events]
            [app.members.views  :refer [members-view-panel]]
            [app.products-section.views :refer [copy-link-notification
                                                form-link product-link
                                                products-section] :as product-section]
            [app.pusher :as pusher]
            [app.routes :as routes]
            [app.styles :refer [break-line-style card-drop-over folder-header-style
                                create-activity-card-style create-activity-section-style
                                creator-name dashboard-screen downward folders-list folders-list-item
                                folders-list-item-padding grid-view-border menu-bottom-border menu-view-buttons-wrapper
                                menu-view-left-button menu-view-right-button sidebar upward] :as styles]
            [app.subs :as subs]
            [app.trash.views  :refer [deleted-folders-panel restore-from-trash
                                      trash-view-panel]]
            [app.workspace-settings.views :refer [workspace-settings-panel]]
            [clojure.pprint :as clojure-print]
            [clojure.string :as str]
            [goog.string.format]
            [highcharts]
            [keybind.core :as key]
            [re-com.core :as re-com :refer [at box gap h-box label line v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [react :as react]
            [reagent-mui.material.tooltip :as tooltip]
            [reagent.core :as r]))
(def show-dialog (r/atom false))
(def show-notification (r/atom false))
(def delete-notification (r/atom false))
(def global-restore-notification (r/atom false))

(defn- get-forms-background [theme_data]
  (let [json-object (.parse js/JSON (:value theme_data))
        {:keys [background_image_url]} (js->clj json-object :keywordize-keys true)]
    background_image_url))

(defn app-bar-normal-right-side [workspace-id]
  (let [token (get-token)
        audience-route (str strive-react-endpoint "/audience?token=" token "&workspace_id=" workspace-id)] ;;&token= token
    [h-box
     :src (at)
     :gap      "10px"
     :align :center
     :children [[buttons/icon-button {:icon search-icon-small :onClick #((-> js/window .-CommandBar .-open))}]
                [box
                 :child [buttons/button {:action :cta :type :primary :title "Audience" :size :medium :onClick #((js/window.location.assign audience-route))}]]]]))

(defn app-bar-trash-right-side [workspace-id]
  (let [data @(re-posh/subscribe [::subs/deleted-selected-folder-data])
        selected-folder-id (:deleted-selected-folder/id data)
        asset-to-restore (r/atom '())]
    (reset! asset-to-restore (conj @asset-to-restore {:type :folder :id selected-folder-id}))
    [h-box
     :src (at)
     :gap      "10px"
     :align :center
     :children [[buttons/icon-button {:icon search-icon-small :onClick #((-> js/window .-CommandBar .-open))}]
                [box
                 :child [buttons/button {:action :cta :type :secondary :title "Restore" :size :medium :onClick #(do (reset! global-restore-notification true)
                                                                                                                    (re-frame/dispatch [::events/navigate [:dashboard-view :id workspace-id]])
                                                                                                                    (restore-from-trash workspace-id asset-to-restore global-restore-notification))}]]
                [box
                 :child [tooltip/tooltip {:title "This folder is deleted"
                                          :placement "bottom"
                                          :arrow true
                                          :classes {:popper (workspace-tooltip)}}
                         [:div [buttons/button {:action :warning :type :primary :title "Deleted" :size :medium :onClick #(println "test")}]]]]]]))

(defn app-bar [{:keys [user workspace-name workspace-id]}]
  (let [selected-workspace-name @(re-frame/subscribe [::subs/selected-workspace-name])
        active-panel (re-frame/subscribe [::subs/active-panel])]
    [h-box
     :class (styles/app-bar)
     :src   (at)
     :children [[box
                 :size "auto"
                 :child
                 [h-box
                  :gap      "24px"
                  :children [[v-box
                              :children
                              [[h-box
                                :children [[label
                                            :class (styles/workspace-name)
                                            :label selected-workspace-name]
                                           [account-settings workspace-id]]]
                               [label
                                :class (creator-name)
                                :label user]]]
                             [:div
                              {:style {:display "flex" :align-items "center"}}
                              [line
                               :size  "1px"
                               :color "#E0DFE4"
                               :style {:height "30px"}]]]]]

                (case @active-panel
                  :deleted-folder-view-panel [app-bar-trash-right-side workspace-id]
                  [app-bar-normal-right-side workspace-id])]]))

(defn activity-data-calc [{:keys [current-sent current-open current-responses previous-sent previous-open previous-responses current-recipients]}]
  [h-box :src (at)
   :class (create-activity-card-style)
   :children [[activity-card {:label "Messages sent"
                              :main-statistic-num (order-num current-sent)
                              :statistic-change (order-num (subs-calc current-sent previous-sent))
                              :movement (- current-sent previous-sent)}]
              [line
               :class (break-line-style)]

              [activity-card {:label "Open rate"
                              :main-statistic-num (display-percentage current-open current-recipients)
                              :statistic-change (open-rate-calc current-open current-sent previous-open previous-sent)
                              :movement (subs-movement-calc current-open current-sent previous-open previous-sent)}]
              [line
               :class (break-line-style)]
              [activity-card {:label "Form responses"
                              :main-statistic-num (order-num current-responses)
                              :statistic-change (order-num (subs-calc current-responses previous-responses))
                              :movement (clean-num (- current-responses previous-responses))}]
              [line
               :class (break-line-style)]

              [activity-card {:label "Response rate"
                              :main-statistic-num (display-percentage current-responses current-recipients)
                              :statistic-change (response-rate-calc current-responses current-sent previous-responses previous-sent)
                              :movement (subs-movement-calc current-responses current-sent previous-responses previous-sent)}]]])

(defn create-activity-card [activity-data-type dashboard? stats]
  (let [{current-7d-sent :current-7d-sent
         current-7d-open :current-7d-open
         current-7d-responses :current-7d-responses
         current-7d-recipients :current-7d-recipients
         previous-7d-sent :previous-7d-sent
         previous-7d-open :previous-7d-open
         previous-7d-responses :previous-7d-responses

         current-30d-sent :current-30d-sent
         current-30d-open :current-30d-open
         current-30d-responses :current-30d-responses
         current-30d-recipients :current-30d-recipients
         previous-30d-sent :previous-30d-sent
         previous-30d-open :previous-30d-open
         previous-30d-responses :previous-30d-responses}
        (if dashboard?
          (into {} (map  (fn [value] {(keyword (:activity value)) (:count_occ value)})  (:statistics/statistics-data @(re-posh/subscribe [::subs/recent-updated-products]))))
          (into {} (map  (fn [value] {(keyword (:activity value)) (:count_occ value)}) stats)))]
    [activity-data-calc (if (= :week activity-data-type)
                          {:current-sent current-7d-sent :current-open current-7d-open :current-responses current-7d-responses :previous-sent previous-7d-sent
                           :previous-open previous-7d-open :previous-responses previous-7d-responses :current-recipients current-7d-recipients}
                          {:current-sent current-30d-sent :current-open current-30d-open :current-responses current-30d-responses
                           :previous-sent previous-30d-sent :previous-open previous-30d-open :previous-responses previous-30d-responses
                           :current-recipients current-30d-recipients})]))


(defn create-activity-section []
  (let [activity-data-type (r/atom :week)]
    (fn []
      [v-box :src (at)
       :class (create-activity-section-style)
       :children [[h-box :src (at)
                   :justify :between
                   :children [[header {:label "Activity" :type :title :size :large}]
                              [h-box :src (at)
                               :gap "2px"
                               :children
                               [[buttons/statistics-tab-selector {:title "7 Days" :on-click #(reset! activity-data-type :week) :is-active (= @activity-data-type :week)}]
                                [buttons/statistics-tab-selector {:title "30 Days" :on-click #(reset! activity-data-type :month) :is-active (= @activity-data-type :month)}]]]]]
                  [create-activity-card  @activity-data-type true]]]
      )))


(defn create-product-block [workspace-id]
  (let [workspace-data  @(re-posh/subscribe [::subs/selected-workspace-data])]
    [h-box :src (at)
     :gap "24px"
     :children [[create-product-card {:label "Product"
                                      :workspace-id workspace-id
                                      :workspace-data workspace-data}]

                [create-product-card {:label "Form"
                                      :workspace-id workspace-id
                                      :workspace-data workspace-data}]]]))

(defn recent-product-block [wid recent-product]
  [h-box :src (at)
   :gap "24px"
   :style {:flex-flow "row wrap"}
   :children [(map (fn [{:keys [id type name workspace_id last_update folder_name theme_data secondary_id folder_id]}]
                     ^{:key (str id name)}
                     [product-card {:product-form-name name
                                    :thumbnail (if  (= type "product")
                                                 theme_data
                                                 (get-forms-background theme_data))
                                    :onClick  (if  (= type "product")
                                                #(js/window.location.assign (product-section/product-link {:template_id secondary_id :workspace-id wid}))
                                                #(js/window.location.assign (product-section/form-link {:id id :workspace-id wid})))
                                    :onChange (println "onChange event")
                                    :label-clicked-out? (r/atom false)
                                    :product-form-id id
                                    :link (if  (= type "product")
                                            (product-section/product-link {:id secondary_id :workspace-id wid})
                                            (product-section/form-link {:id id :workspace-id wid}))
                                    :show-workspaces-menu? (r/atom false)
                                    :copyLink (if  (= type "product")
                                                #(wevents/copy-link (product-section/product-link {:id secondary_id :workspace-id wid}))
                                                #(wevents/copy-link (product-section/form-link {:id id :workspace-id wid}))) 
                                    :type (if  (= type "product")
                                            :product
                                            :form)
                                    :workspace-id wid
                                    :selected-folder-id workspace_id
                                    :showing-settings? (r/atom false)
                                    :sent-value nil
                                    :last-updated last_update
                                    :product-form-secondary-id secondary_id
                                    :product-description nil
                                    :in-workspace folder_name
                                    :menu-id (r/atom "ellipsis-menu-move-to-button")
                                    :delete-notification nil
                                    :show-ellipsis-menu? false
                                    :folder-id folder_id}])
                   recent-product)]])

(defn template-header [workspace-id]
  [v-box
   :src (at)
   :gap "8px"
   :children [[header {:label "Create a project" :type :title :size :large}]
              [header {:label "Turn any template in our gallery into a new project" :type :normal :size :regular}]]])

(defn folder-header []
  (r/create-class
  {:reagent-render
    (fn [selected-folder-id workspace-id view-type menu-id show-create-menu?]
      (let [selected-folder-name @(re-frame/subscribe [::subs/selected-folder-name])]
        (r/after-render (fn []
                          (pusher/update-product-event selected-folder-id (fn [_]
                                                                            (re-frame/dispatch [::wevents/get-products {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/update-form-event selected-folder-id (fn [_]
                                                                         (re-frame/dispatch [::wevents/get-forms {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/move-product-event selected-folder-id (fn [_]
                                                                          (re-frame/dispatch [::wevents/get-products {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/move-form-event selected-folder-id (fn [_]
                                                                       (re-frame/dispatch [::wevents/get-forms {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/delete-product-event selected-folder-id (fn [_]
                                                                            (re-frame/dispatch [::wevents/get-products {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/delete-form-event selected-folder-id (fn [_]
                                                                         (re-frame/dispatch [::wevents/get-forms {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/duplicate-form-event selected-folder-id (fn [_]
                                                                            (re-frame/dispatch [::wevents/get-forms {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/duplicate-product-event selected-folder-id (fn [_]
                                                                               (re-frame/dispatch [::wevents/get-products {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/copy-product-event selected-folder-id (fn [_]
                                                                          (re-frame/dispatch [::wevents/get-products {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/copy-form-event selected-folder-id (fn [_]
                                                                       (re-frame/dispatch [::wevents/get-forms {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/move-multiple-event selected-folder-id (fn [_]
                                                                           (re-frame/dispatch [::wevents/get-projects {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/copy-multiple-event selected-folder-id (fn [_]
                                                                           (re-frame/dispatch [::wevents/get-projects {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/undo-delete-event selected-folder-id (fn [_]
                                                                         (re-frame/dispatch [::wevents/get-projects {:workspace-id workspace-id :folder-id selected-folder-id}])))
                          (pusher/delete-multiple-event selected-folder-id (fn [_]
                                                                           (re-frame/dispatch [::wevents/get-projects {:workspace-id workspace-id :folder-id selected-folder-id}])))))
        [h-box
         :src (at)
         :justify :between
         :children [[h-box
                     :gap "20px"
                     :align :center
                     :children [[header {:label (if (= selected-folder-name "") "Untitled" selected-folder-name)
                                         :type :title :size :large :style (folder-header-style selected-folder-name)} ]
                                (when (= :list @view-type) [:div {:id "create-new-button"}
                                                            [buttons/icon-button {:icon plus-icon :attr {:aria-describedby "create-new-button"} :onClick #(do (reset! menu-id "create-new-button")
                                                                                                                                                              (swap! show-create-menu? not))}]])]]
                    [h-box
                     :class (menu-view-buttons-wrapper)
                     :children [[h-box
                                 :style {:border-bottom-left-radius "5px"
                                         :border-top-left-radius "5px"}
                                 :class (menu-view-left-button (= :grid @view-type))
                                 :children [[buttons/icon-button {:icon grid-view-icon :size 25  :onClick #(reset! view-type :grid)}]]]
                                [h-box
                                 :style {:border-bottom-right-radius "5px"
                                         :border-top-right-radius "5px"}
                                 :class (menu-view-right-button (= :list @view-type))
                                 :children [[buttons/icon-button {:icon list-view-icon :size 25 :onClick #(reset! view-type :list)}]]]]]]]))}))

(defn dashboard-menu-bottom [workspace-id]
  (let [route-params (re-frame/subscribe [::subs/active-panel])]
    [v-box
     :src (at)
     :class (menu-bottom-border)
     :children
     [[v-box
       :src (at)
       :gap "4px"
       :class (folders-list-item-padding)
       :children [[buttons/left-icon-button {:icon delete-icon :name "Trash" :selected (= @route-params :trash-view-panel)
                                             :onClick #(re-frame/dispatch [::events/navigate [:trash-view :id workspace-id]])}]]]]]))

(defn dashboard-full-screen [workspace-id recent-product] 
  [v-box
   :src (at)
   :size "auto"
   :gap "20px"
   :style {:overflow-y "auto"}
   :children [[create-activity-section workspace-id]
              [template-header workspace-id]
              [create-product-block workspace-id]
              [header {:label "Recently edited" :type :title :size :large}]
              [recent-product-block workspace-id recent-product]]])

(defn products-grid-view [workspace-id selected-folder-id data create-new-product create-new-form]
  [v-box
   :src (at)
   :gap "24px"
   :children [[products-section workspace-id selected-folder-id data "Products" :product create-new-product delete-notification]
              [:hr {:class (grid-view-border)}]
              [products-section workspace-id selected-folder-id data "Forms" :form create-new-form delete-notification]]])


(defn onChange [% id type workspace-id selected-folder-id local-data index]
  (if (= :product type)
    (do  (re-frame/dispatch [::wevents/update-product-name-local {:name % :products  (:selected-folder/projects local-data) :index index}])
         (re-frame/dispatch [::wevents/update-product-name {:product-id id :name % :workspace-id workspace-id :folder-id selected-folder-id}]))
    (do (re-frame/dispatch [::wevents/update-form-name-local {:name % :forms  (:selected-folder/forms local-data) :index index}])
        (re-frame/dispatch [::wevents/update-form-name {:form-id id :name % :workspace-id workspace-id :folder-id selected-folder-id}]))))


(defn products-list-view [workspace-id selected-folder-id data-combined unfiltered-data menu-id-create show-create-menu? create-new-product create-new-form local-data]
  (let [selected? (r/atom false)
        move-notification (r/atom false)
        copy-notification (r/atom false) 
        delete-notification (r/atom false)
        assets-selected (r/atom '())
        global-ticked? (r/atom false)
        selected-all-ticked? (r/atom false)
        menu-id (r/atom "")
        show-workspaces-menu? (r/atom false)
        action (r/atom nil)
        context-menu (r/atom nil)
        show-context-menu? (r/atom false)
        workspace-data  @(re-posh/subscribe [::subs/selected-workspace-data])
        array-of-ticked (r/atom (mapv (fn [e] {:id (:id e) :ticked  false}) @data-combined))
        actions [{:title "Move to" :id "move-multiple-btn" :action #(do
                                                                      (swap! show-workspaces-menu? not)
                                                                      (reset! menu-id "move-multiple-btn")
                                                                      (reset! action :move))}
                 {:title "Copy to" :id "copy-multiple-btn" :action #(do
                                                                      (swap! show-workspaces-menu? not)
                                                                      (reset! menu-id "copy-multiple-btn")
                                                                      (reset! action :copy))}
                 {:title "Delete" :id "delete-multiple-btn" :action #(do
                                                                       (wevents/delete-multiple-assets workspace-id selected-folder-id assets-selected delete-notification)
                                                                       (reset! assets-selected nil) 
                                                                       (reset! array-of-ticked (mapv (fn [x] (update x :ticked (fn [e]
                                                                                                                                 false))) @array-of-ticked)))}]
        individual-asset-actions [{:title "View"  :action #(do
                                                             (js/window.location.assign (:link @context-menu))
                                                             (reset! context-menu nil))}
                                  {:title "Rename"  :action #(do
                                                               (swap! (:label-clicked-out? @context-menu) not)
                                                               (reset! context-menu nil))}
                                  {:title "Delete"  :action #(do
                                                               (if (= (:type @context-menu) :product)
                                                                 (re-posh/dispatch [::wevents/delete-product  {:workspace-id workspace-id :folder-id selected-folder-id :product-id (:id @context-menu)}])
                                                                 (re-posh/dispatch [::wevents/delete-form  {:workspace-id workspace-id :folder-id selected-folder-id :form-id (:id @context-menu)}]))
                                                               (re-posh/dispatch  [::wevents/add-last-action  {:asset [{:type (:type @context-menu) :id (str (:id @context-menu))}]
                                                                                                               :name (:name @context-menu)
                                                                                                               :type (if (= (:type @context-menu) :product)
                                                                                                                       "Product"
                                                                                                                       "Form")}])
                                                               (swap! delete-notification not)
                                                               (reset! context-menu nil))}]]
    (fn [workspace-id selected-folder-id data-combined]
      [v-box
       :src      (at)
       :height "100vh"
       :size "auto"
       :children [[basic-table-with-checkbox {:data data-combined
                                              :unfiltered-data unfiltered-data
                                              :columns {:names ["Name" "Created at" "Last Updates"] :values [:name :created_at_before :updated_at_before] :values-sort [:name :created_at :updated_at]}
                                              :assets-selected assets-selected
                                              :selected-all-ticked? selected-all-ticked?
                                              :selected? selected?
                                              :array-of-ticked array-of-ticked
                                              :actions individual-asset-actions
                                              :context-menu context-menu
                                              :show-context-menu? show-context-menu?
                                              :onChange onChange
                                              :workspace-id workspace-id
                                              :selected-folder-id selected-folder-id
                                              :local-data local-data}]
                  (when @show-create-menu? [create-menu {:menu-id menu-id-create :show-create-menu? show-create-menu?
                                                         :create-new-product create-new-product :create-new-form create-new-form}])

                  [workpaces-menu
                   {:menu-id menu-id :show-workspaces-menu? show-workspaces-menu? :workspace-id workspace-id :selected-folder-id selected-folder-id :workspace-data workspace-data :type type  :action action :assets-selected assets-selected :move-notification move-notification :copy-notification copy-notification :context-menu (r/atom false) :showing-settings? (r/atom false) :array-of-ticked array-of-ticked}]
                  (when @copy-link-notification
                    [mui-snackbar {:main-text "Link copied. Recipients of this link should also be given access permission." :open copy-link-notification}])
                  (when @move-notification [mui-snackbar {:main-text "The files you have selected have been safely moved" :open move-notification}])
                  (when @copy-notification [mui-snackbar {:main-text "The files you have selected have been safely copied" :open copy-notification}])
                  (when @delete-notification [mui-snackbar {:main-text "The files you have selected have been deleted" :open delete-notification}])
                  (when (seq @assets-selected)
                    [mutliselect-actions-pop-up {:selected? selected?
                                                 :global-ticked? global-ticked?
                                                 :array-of-ticked array-of-ticked
                                                 :selected-all-ticked? selected-all-ticked?
                                                 :assets-selected assets-selected
                                                 :all-assets @data-combined
                                                 :actions actions}])]])))
(defn get-list-view-data [data workspace-id selected-folder-id]
  (map  #(-> %
             (assoc :created_at_before (time-ago (% :created_at)))
             (assoc :updated_at_before (time-ago (% :updated_at)))
             (assoc :icon (if (% :product_description)
                            [product-icon {:size 20}]
                            [form-icon {:size 20}]))
             (assoc :type (if (% :product_description)
                            :product
                            :form))
             (assoc :secondary-id (if (% :template_id)
                                    (int (% :template_id))
                                    (% :form_id)))
             (assoc :product-description (if (% :product_description)
                                           (% :product_description)
                                           nil))
             (assoc :link (if (% :product_description)
                            (product-link {:template_id (% :template_id)
                                           :workspace-id workspace-id
                                           :folder-id selected-folder-id})
                            (form-link {:id (% :id)
                                        :workspace-id workspace-id
                                        :folder-id selected-folder-id})))) (concat (:selected-folder/projects @data) (:selected-folder/forms @data))))


(defn folders-panel [workspace-id]
  (let [data (re-posh/subscribe [::subs/selected-folder-data])
        is-folder-deleted?  (re-posh/subscribe [::subs/is-selected-folder-deleted?])
        folder-status (first (:folder-status/status @(re-posh/subscribe [::subs/get-folder-status])))
        is-folder-in-trash (and (:is_active folder-status) (some? (:deleted_at folder-status)))
        is-folder-active (and (:is_active folder-status) (nil? (:deleted_at folder-status)))
        is-folder-permanently-deleted (and (false? (:is_active folder-status)) (some? (:deleted_at folder-status)))
        view-type (r/atom :grid)
        activity-data-type (r/atom :week)
        show-create-menu? (r/atom false)
        menu-id (r/atom "")
        create-new-product #(re-posh/dispatch [::wevents/create-product {:workspace-id workspace-id :folder-id (:selected-folder/id @data)}])
        create-new-form #(re-posh/dispatch [::wevents/create-form {:workspace-id workspace-id :folder-id (:selected-folder/id @data)}])
        stats (re-posh/subscribe [::subs/recent-updated-products])]
    (fn []
      [v-box
       :src (at)
       :size "auto"
       :gap "24px"
       :style {:overflow-y "auto"
               :padding "0px 20px"
               :margin-top "48px"}
       :children [;;[buttons/right-icon-button {:icon chevron-down-icon :name "Share folder"}] ;;Majd: DO NOT UNCOMMENT AND DO NOT DELETE
                  ;; [:div] [:div]
                  ;; [v-box :src (at)
                  ;;  :class (create-activity-section-style)
                  ;;  :children [[h-box :src (at)
                  ;;              :justify :between
                  ;;              :children [[header {:label "Activity" :type :title :size :large}]
                  ;;                         [h-box :src (at)
                  ;;                          :gap "2px"
                  ;;                          :children
                  ;;                          [[buttons/statistics-tab-selector {:title "7 Days" :on-click #(reset! activity-data-type :week) :is-active (= @activity-data-type :week)}]
                  ;;                           [buttons/statistics-tab-selector {:title "30 Days" :on-click #(reset! activity-data-type :month) :is-active (= @activity-data-type :month)}]]]]]
                  ;;             [create-activity-card  @activity-data-type false (:statistics/statistics-folder-data @stats)]]] 
                  [folder-header (:selected-folder/id @data) workspace-id view-type menu-id show-create-menu?]
                  (if (nil? @is-folder-deleted?)
                    [v-box
                     :src (at)
                     :justify :center
                     :align :center
                     :height "calc(100% - 60px)"
                     :gap "17px"
                     :children
                     (if is-folder-in-trash [[recycle-trash-icon]
                                             [header {:label "Oops!" :type :x-large :size :bold}]
                                             [header {:label "This folder was deleted" :type :x-large :size :bold}]
                                             [h-box
                                              :children [[buttons/button {:action :cta :type :primary
                                                                          :title "Back to dashboard"
                                                                          :size :medium
                                                                          :onClick #(re-frame/dispatch [::events/navigate [:dashboard-view :id workspace-id]])}]
                                                         [buttons/button {:action :warning :type :primary
                                                                          :title "Go to trash"
                                                                          :size :medium
                                                                          :onClick #(re-frame/dispatch [::events/navigate [:trash-view :id workspace-id]])}]]]]

                         (if is-folder-permanently-deleted
                           [[trash-big-icon]
                            [header {:label "Oops!" :type :x-large :size :bold}]
                            [header {:label "Folder was permanently removed" :type :x-large :size :bold}]
                            [h-box
                             :children [[buttons/button {:action :cta :type :primary
                                                         :title "Back to dashboard"
                                                         :size :medium
                                                         :onClick #(re-frame/dispatch [::events/navigate [:dashboard-view :id workspace-id]])}]]]]

                           [[not-found-icon]
                            [header {:label "Oops!" :type :x-large :size :bold}]
                            [header {:label "Folder not found" :type :x-large :size :bold}]
                            [h-box
                             :children [[buttons/button {:action :cta :type :primary
                                                         :title "Back to dashboard"
                                                         :size :medium
                                                         :onClick #(re-frame/dispatch [::events/navigate [:dashboard-view :id workspace-id]])}]]]]))
]
                    (if (and (= (count (:selected-folder/projects @data)) 0) (= (count (:selected-folder/forms @data)) 0))
                      [v-box
                       :src (at)
                       :justify :center
                       :align :center
                       :height "calc(100% - 120px)"
                       :gap "17px"
                       :children [[new-folder-icon]
                                  [header {:label "This folder is empty" :type :title :size :large}]
                                  [header
                                   {:label "Projects here will be private until you share them with others."
                                    :type :normal :size :regular}]
                                  [:div {:id "create-new-project-button"}
                                   [buttons/button {:action :cta :type :primary
                                                    :title "Create Project"
                                                    :size :medium
                                                    :icon plus-white-icon
                                                    :onClick #(do (swap! show-create-menu? not)
                                                                  (reset! menu-id "create-new-project-button"))}]]
                                  [h-box
                                   :children [(when @show-create-menu? [create-menu {:menu-id menu-id :show-create-menu? show-create-menu?
                                                                                     :create-new-product create-new-product :create-new-form create-new-form}])]]]]
                      (if (= @view-type :grid)
                        [products-grid-view workspace-id (:selected-folder/id @data) @data create-new-product create-new-form]
                        [products-list-view workspace-id (:selected-folder/id @data) (r/atom (get-list-view-data data workspace-id (:selected-folder/id @data))) (r/atom (get-list-view-data data workspace-id (:selected-folder/id @data))) menu-id show-create-menu? create-new-product create-new-form @data])))]])))

(defn workspace-full-screen [active-panel workspace-id workspace-name recent-product]
  [h-box
   :size "auto"
   :class (dashboard-screen)
   :children [[v-box
               :src (at)
               :gap "24px"
               :size "auto"
               :children [(case active-panel
                            :workspace-settings-panel [workspace-settings-panel]
                            :folder-view-panel [folders-panel workspace-id]
                            :account-settings-panel [account-settings-panel]
                            :members-view-panel [members-view-panel workspace-id]
                            :trash-view-panel [trash-view-panel workspace-id workspace-name]
                            :dashboard-view-panel [dashboard-full-screen workspace-id recent-product]
                            :deleted-folder-view-panel [deleted-folders-panel workspace-id]
                            [dashboard-full-screen workspace-id recent-product])]]]])
(defn drag-ended [index destination-index]
  (let [{workspace-id :selected-workspace/id workspace-folders :selected-workspace/folders} @(re-posh/subscribe [::subs/selected-workspace-data])
        new-list (change-list index destination-index workspace-folders)]
    (re-frame/dispatch [::wevents/reorder-folders {:workspace-id workspace-id :new-folder-list (vec new-list)}])))

(defn- dragDirection [{:keys [dragIndex hoverIndex clientOffset sourceClientOffset initialClientOffset]}]
  (let [hoverMiddleY (/ (- (:y initialClientOffset) (:y sourceClientOffset)) 2)
        hoverClientY (- (:y clientOffset) (:y sourceClientOffset))
        className  (r/atom nil)]
    (when (and (< (:index dragIndex) hoverIndex) (> hoverClientY hoverMiddleY))
      (reset! className (downward)))
    (when (and (> (:index dragIndex) hoverIndex) (< hoverClientY hoverMiddleY))
      (reset! className (upward)))
    className))

(defn row [data workspace-folders selected-folder-data restored-folder-data selected-workspace-id deletable? delete-folder-action clicked-folder-details is-new?]
  (let [{:keys [id name workspace_id order count]} (nth workspace-folders (:index data))
        route-params (re-frame/subscribe [::subs/active-panel])
        link (folder-link selected-workspace-id workspace_id)
        selected? (or (and (= (:selected-folder/id selected-folder-data) workspace_id) (= @route-params :folder-view-panel)) (= (:restored-folder/id restored-folder-data) workspace_id))
        deletable? (= 0 count)
        dropRef (react/useRef nil)
        dropping-values (useDrop (fn [item monitor]
                                   #js {:accept "any"
                                        :drop (fn [item]
                                                (if (= "card" (.-type item))
                                                  #js{:identifier (nth workspace-folders (:index data))}
                                                  (drag-ended (.-index item) (:index data))))

                                        :collect (fn [^js/monitor monitor]
                                                   #js{:canDrop (.canDrop monitor)
                                                       :isOver  (.isOver monitor)
                                                       :sourceClientOffset (.getSourceClientOffset monitor)
                                                       :item (.getItem monitor)})}))
        dragging-values (useDrag (fn []
                                   #js {:type "any"
                                        :item (fn [] #js{:id id
                                                         :index (:index data)})

                                        :collect (fn [^js/monitor monitor]
                                                   #js{:isDragging (.isDragging monitor)
                                                       :clientOffset (.getClientOffset monitor)
                                                       :initialClientOffset (.getInitialClientOffset monitor)
                                                       :item (.getItem monitor)})}))
        preview (nth (js->clj dragging-values) 2)
        drag-el (second (js->clj dragging-values))
        drop-el (second (js->clj dropping-values))
        drop (first (js->clj dropping-values :keywordize-keys true))
        drag (first (js->clj dragging-values :keywordize-keys true))
        className (when (and (:initialClientOffset drag) (:isOver drop) (and (not (nil? (:item drop))) (not= "card" (:type (:item drop)))))
                    (dragDirection {:dragIndex (:item drag)  :hoverIndex  (:index data) :clientOffset (:clientOffset drag)
                                    :sourceClientOffset (:sourceClientOffset drop)
                                    :initialClientOffset (:initialClientOffset drag)}))

        card-drop-over-class (if (and (:initialClientOffset drag) (:isOver drop))
                               (r/atom (card-drop-over)) (r/atom nil))]
    (preview (drag-el (drop-el dropRef)))
    (r/as-element
     ^{:key (str id "-" name "-" (:index data))}
     [:div  {:key (str id "-" name "-" (:index data))
             :style (merge (:style data) {:opacity (if (:isDragging (first (js->clj dragging-values :keywordize-keys true))) 0 1)})
             :id (str "folder-item-list" (:index data))
             :ref  dropRef
             :class @card-drop-over-class}
      [folder-items/folder-item {:name name
                                 :workspace-id selected-workspace-id
                                 :folder-id id
                                 :selected selected?
                                 :onChange (fn [val]
                                             (re-frame/dispatch [::wevents/update-folder {:workspace-folders workspace-folders
                                                                                          :name (str/trim val)
                                                                                          :index (:index data)}])
                                             (re-posh/dispatch [::wevents/update-folder-name {:folder-id workspace_id
                                                                                              :name (str/trim val)
                                                                                              :workspace-id selected-workspace-id}]))
                                 :onClick #(do
                                             (re-posh/dispatch [::wevents/add-selected-folder {:selected-folder/id workspace_id
                                                                                               :selected-folder/name name 
                                                                                               :selected-folder/new false}])
                                             (re-posh/dispatch [::wevents/add-selected-folder-order {:selected-folder/order order}])
                                             (re-posh/dispatch [::wevents/add-restored-folder {:restored-folder/id "nil"}])
                                             (re-frame/dispatch [::events/navigate [:folder-view :folder-id workspace_id :id selected-workspace-id]]))
                                 :onDelete #(delete-folder-action)
                                 :confirmDelete #(do (reset! show-dialog true))
                                 :copyLink #(do (.stopPropagation %)
                                                (copy-link link)
                                                (reset! show-notification true))
                                 :new-folder? (and (= (:selected-folder/id selected-folder-data) workspace_id) (:selected-folder/new selected-folder-data))
                                 :deletable? deletable?
                                 :is-new? is-new?
                                 :clicked-folder-details clicked-folder-details
                                 :clicked-workspace-id workspace_id
                                 :clicked-workspace-name name
                                 :count count
                                 :delete-notification delete-notification}
       :key  (str id "-" name "-" (:index data))]
      [gap :size "4px"
      ;;  :class (if (nil? className) (normal) @className)
       ]])))

(defn calc-order [selected-folder-data selected-folder-index route-params workspace-folders] 
  (if (= (count workspace-folders) 0)
    0
    (if (= (count workspace-folders) 1)
      (inc (:order (nth workspace-folders 0)))
      (if (or (= @route-params :dashboard-view-panel) (and (= @route-params :folder-view-panel) (some? (:selected-folder/id selected-folder-data)) (= (count workspace-folders) (inc selected-folder-index))))
        (inc (:order (nth workspace-folders (dec (count workspace-folders)))))
        (/ (+ (:selected-folder/order selected-folder-data) (:order (nth workspace-folders (inc selected-folder-index)))) 2.0)))))

(defn window-list [dims workspace-folders selected-folder-data restored-folder-data workspace-id deletable? delete-folder-action clicked-folder-details]
  (let [listRef (react/useRef)]
    (react/useEffect
     (fn []
       (js-invoke (.-current listRef) "scrollToItem"
                  (.indexOf (to-array workspace-folders)
                            (some #(when (= (:selected-folder/id selected-folder-data) (:workspace_id %)) %)
                                  workspace-folders))
                  "center")) #js [workspace-folders])
    (r/as-element
     [(r/adapt-react-class FixedSizeList)
      {:height (- (:height dims) 100)
       :item-count (count workspace-folders)
       :item-size 43
       :ref listRef
       :layout "vertical"
       :width (:width dims)}
      (fn [data]
        (let [data (js->clj data :keywordize-keys true)]
          (r/as-element
           [:f> row data workspace-folders selected-folder-data restored-folder-data workspace-id
            deletable? delete-folder-action clicked-folder-details])))])))

(defn dashboard-view-panel []
  (let [clicked-folder-details (r/atom {:folder-id nil :folder-name nil})]
    (r/create-class
     {:reagent-render
      (fn [{:keys [workspace-folders workspace-id workspace-name]}]
        (pusher/create-folder workspace-id (fn [data]
                                             (re-posh/dispatch [::wevents/get-folders  workspace-id])
                                             (re-frame/dispatch [::events/navigate [:folder-view :folder-id (:folder-id (js->clj data :keywordize-keys true)) :id workspace-id]])
                                             (println  (js->clj data :keywordize-keys true))
                                             (re-posh/dispatch [::wevents/add-selected-folder {:selected-folder/id (:folder-id (js->clj data :keywordize-keys true))
                                                                                               :selected-folder/name (:name (js->clj data :keywordize-keys true)) 
                                                                                               :selected-folder/new true}])
                                             (re-posh/dispatch [::wevents/add-selected-folder-order {:selected-folder/order (:order (js->clj data :keywordize-keys true))}])
                                             (re-posh/dispatch [::wevents/add-restored-folder {:restored-folder/id "nil"}])))
        (pusher/update-workspace-name-event  workspace-id (fn [_]
                                                            (re-frame/dispatch [::wevents/get-workspaces])))
        (pusher/delete-folder workspace-id (fn [data]
                                             (re-posh/dispatch [::wevents/get-folders  workspace-id])
                                             (re-posh/dispatch [::login-events/add-token  (:token (js->clj data :keywordize-keys true))])))
        (pusher/restore-folder workspace-id (fn [data]
                                              (re-posh/dispatch [::wevents/get-folders  workspace-id])
                                              (re-posh/dispatch [::login-events/add-token  (:token (js->clj data :keywordize-keys true))])))
        (pusher/update-folder-event workspace-id (fn [data]
                                                   (re-frame/dispatch [::wevents/get-folders workspace-id])
                                                   (re-posh/dispatch [::login-events/add-token  (:token (js->clj data :keywordize-keys true))])))
        (pusher/create-folder workspace-id (fn [data]
                                             (re-posh/dispatch [::wevents/get-folders  workspace-id])
                                             (re-frame/dispatch [::events/navigate [:folder-view :folder-id (:folder-id (js->clj data :keywordize-keys true)) :id workspace-id]])
                                             (println  (js->clj data :keywordize-keys true))
                                             (re-posh/dispatch [::wevents/add-selected-folder {:selected-folder/id (:folder-id (js->clj data :keywordize-keys true))
                                                                                               :selected-folder/name (:name (js->clj data :keywordize-keys true)) 
                                                                                               :selected-folder/new true}])
                                             (re-posh/dispatch [::wevents/add-selected-folder-order {:selected-folder/order (:order (js->clj data :keywordize-keys true))}])
                                             (re-posh/dispatch [::wevents/add-restored-folder {:restored-folder/id "nil"}])))
        (pusher/restore-to-workspace workspace-id (fn [data]
                                                    (re-posh/dispatch [::wevents/get-deleted-assets workspace-id])
                                                    (re-posh/dispatch [::wevents/get-folders workspace-id])
                                                    (re-posh/dispatch [::login-events/add-token  (:token (js->clj data :keywordize-keys true))])))
        (pusher/empty-trash-event workspace-id (fn [data]
                                                 (re-posh/dispatch [::wevents/get-deleted-assets workspace-id])
                                                 (re-posh/dispatch [::wevents/get-folders workspace-id])
                                                 (re-posh/dispatch [::login-events/add-token  (:token (js->clj data :keywordize-keys true))])))

        (let [active-panel (re-frame/subscribe [::subs/active-panel])
              selected-folder-data @(re-posh/subscribe [::subs/selected-folder-data])
              restored-folder-data @(re-posh/subscribe [::subs/restored-folder-data])
              cancel-dialog (fn []
                              (reset! show-dialog false)
                              false)
              folder-name (:selected-folder/name selected-folder-data)
              deletable? (and (= 0 (count (:selected-folder/forms selected-folder-data))) (= 0 (count (:selected-folder/projects selected-folder-data))))
              folder-id (:selected-folder/id selected-folder-data)
              route-params (re-frame/subscribe [::subs/active-panel])
              selected-folder-index @(re-frame/subscribe [::subs/selected-folder-index])
              delete-folder-action #(do
                                      (re-posh/dispatch [::wevents/delete-folder-local  {:workspace-folders workspace-folders :folder-id (:folder-id @clicked-folder-details)}])
                                      (re-posh/dispatch [::wevents/delete-folder  {:workspace-id workspace-id :folder-id (:folder-id @clicked-folder-details)}])
                                      (re-frame/dispatch [::events/navigate [:dashboard-view :id workspace-id]])

                                      (re-posh/dispatch [::wevents/add-last-action  {:asset [{:type :folder :id (:folder-id @clicked-folder-details)}]
                                                                                     :name (:folder-name @clicked-folder-details)
                                                                                     :type "Folder"}])

                                      (swap! delete-notification not))
              {recent-product :statistics/recent-products} @(re-frame/subscribe [::subs/recent-updated-products])
              {last-action-id :last-action/id} @(re-posh/subscribe [::subs/last-action-folder-data])
              undo-delete #(do
                             (re-posh/dispatch [::wevents/restore  {:workspace-id workspace-id :assets-id (:asset last-action-id) :folder-id folder-id}]) 
                             (re-posh/dispatch [::wevents/add-restored-folder {:restored-folder/id (:id (first (:asset last-action-id)))}]))]
          (key/bind! "ctrl-z" ::my-trigger undo-delete)
          [(r/adapt-react-class DndProvider)
           {:backend HTML5Backend}
           (r/as-element
            [h-box
             :src (at)
             :size "auto"
             :children [[v-box
                         :src (at)
                         :class (folders-list)
                         :gap "4px"
                         :children [[v-box :size "auto" :class (folders-list-item)
                                     :children [[buttons/folder-menu-button {:name "Dashboard" :icon dashboard-icon
                                                                             :selected (= @route-params :dashboard-view-panel)
                                                                             :onClick #(re-frame/dispatch [::events/navigate [:dashboard-view :id workspace-id]])}]
                                                [buttons/folder-list-header {:name "Workspace Folders" :count (count workspace-folders) :onClick #(re-frame/dispatch [::wevents/add-folder workspace-id (calc-order selected-folder-data selected-folder-index route-params workspace-folders)])}]
                                                (r/as-element [(r/adapt-react-class AutoSizer)
                                                               {}
                                                               (fn [dims]
                                                                 (let [dims (js->clj dims :keywordize-keys true)]
                                                                   (r/as-element
                                                                    [:f> window-list dims workspace-folders selected-folder-data restored-folder-data workspace-id deletable? delete-folder-action clicked-folder-details])))])]]
                                    [dashboard-menu-bottom workspace-id]]]
                        [workspace-full-screen @active-panel workspace-id workspace-name recent-product]
                        (when @show-dialog [pop-up {:main-text (str "Delete '" (:folder-name @clicked-folder-details) "'?")
                                                    :on-cancel cancel-dialog :on-confirm #(do (delete-folder-action)
                                                                                              (cancel-dialog))
                                                    :cancel-button-text "Cancel" :confirm-button-text "Delete folder"
                                                    :continue-button-text "Continue" :deletable? deletable?}])
                        (when @show-notification [mui-snackbar {:main-text "Link copied. Recipients of this link should also be given access permission." :open show-notification}])
                        (when @delete-notification [mui-action-snackbar {:main-text (str (:type last-action-id) " '" (:name last-action-id) "' deleted") :open delete-notification :title "UNDO" :action undo-delete}])
                        (when @global-restore-notification [mui-snackbar {:main-text "The files you have selected have been safely restored." :open global-restore-notification}])]])]))})))

(defn workspace-list-item [{:keys [tenant_id name logo]} selected-id]
  [v-box
   :children [[workspace_btn
               {:name name
                :id tenant_id
                :selected (= tenant_id selected-id)
                :logo logo
                :onClick  (fn []
                            (pusher/unsubscribe-workspace selected-id)
                            (re-frame/dispatch [::events/navigate [:dashboard-view :id tenant_id]])
                            (re-posh/dispatch [::wevents/add-selected-workspace {:selected-workspace/id tenant_id :selected-workspace/name name}]))}]
              [gap :size "24px"]]])

(defn dashboard-panel-view [workspace-data selected-id workspace-name workspace-folders workspace-on-click user-name]
  [h-box
   :src      (at)
   :children [[v-box
               :src (at)
               :class (sidebar)
               :children [(for [workspace-id workspace-data]
                            ^{:key workspace-id} [workspace-list-item workspace-id selected-id])
                          [new_workspace {:onClick workspace-on-click}]]]
              [v-box
               :src (at)
               :size "auto"
               :children [[app-bar {:user user-name :workspace-name workspace-name :workspace-id selected-id}]
                          [dashboard-view-panel {:workspace-folders workspace-folders :workspace-id selected-id :workspace-name workspace-name}]]]]])

(defn dashboard-panel []
  (let [get-workspace-data @(re-frame/subscribe [::subs/get-workspace-data])
        {user-name :user/name} @(re-posh/subscribe [::subs/user-name])
        {selected-id :selected-workspace/id workspace-name :selected-workspace/name workspace-folders :selected-workspace/folders} @(re-posh/subscribe [::subs/selected-workspace-data])]
    [dashboard-panel-view get-workspace-data selected-id workspace-name workspace-folders #(re-frame/dispatch [::events/navigate [:new-workspace]]) user-name]))

(defmethod routes/panels :dashboard-panel [] [dashboard-panel])
(defmethod routes/panels :dashboard-view-panel [] [dashboard-panel])
(defmethod routes/panels :folder-view-panel [] [dashboard-panel])
(defmethod routes/panels :workspace-settings-panel [] [dashboard-panel])
(defmethod routes/panels :account-settings-panel [] [dashboard-panel])
(defmethod routes/panels :members-view-panel [] [dashboard-panel])
(defmethod routes/panels :trash-view-panel [] [dashboard-panel])
(defmethod routes/panels :deleted-folder-view-panel [] [dashboard-panel])